import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

import { logoutUser } from "../redux/auth/actions";

import HomeIcon from "../assets/images/games-icon/new/home.png";
import CasinoIcon from "../assets/images/games-icon/new/livedealer.png";
import InplayIcon from "../assets/images/games-icon/inplay-icon.png";
import aviator from "../assets/images/games-icon/aviator.png";

import CricketIcon from "../assets/images/games-icon/new/exchnage.png";
import SoccerIcon from "../assets/images/games-icon/soccer-icon.png";
import TennisIcon from "../assets/images/games-icon/tennis-icon.png";
import horseracingIcon from "../assets/images/games-icon/horseracing-icon.png";
import playtechGames from "../assets/images/games-icon/new/poker-chip.png";
import TopGames from "../assets/images/games-icon/new/topgames.png";
import SlotsGames from "../assets/images/games-icon/new/slots.png";
import PragmaticGames from "../assets/images/games-icon/new/seven.png";
import IndianGames from "../assets/images/games-icon/new/game.png";
import CrashGames from "../assets/images/games-icon/new/crash.png";
import TableTennisIcon from "../assets/images/games-icon/table-tennis-icon.png";
import Badminton from "../assets/images/games-icon/badminton-icon.png";
import ArcheryIcon from "../assets/images/games-icon/archery-icon.png";
import MotorSportIcon from "../assets/images/games-icon/motor-sport-icon.png";
import GreyhoundIcon from "../assets/images/games-icon/greyhoundracing-icon.png";
import PoliticsIcon from "../assets/images/games-icon/politics-icon.png";
import EzugiIcon from "../assets/images/games-icon/new/ezugi.png";
import EvolutionIcon from "../assets/images/games-icon/new/evolution.png";
import SupernowaICon from "../assets/images/games-icon/new/xpg.png";
import QtechIcon from "../assets/images/games-icon/new/qtech.png";
import VivoIcon from "../assets/images/games-icon/new/vivo.png";
import XPGICon from "../assets/images/games-icon/new/supernowa.png";
import AviatorIcon from "../assets/images/games-icon/new/aviation.png";
import JetXIcon from "../assets/images/games-icon/new/jet.png";

import WalletIcon from "../assets/images/WalletIcon.png";
import UserIcon from "../assets/images/user-icon.svg";
import BetIcon from "../assets/images/games-icon/new/mybets.png";
import AcStatement from "../assets/images/games-icon/new/accountstatement.png";
import LogoutIconImg from "../assets/images/games-icon/new/log-out.png";
import BonusImg from "../assets/images/games-icon/new/bonus.png";
import refferal from "../assets/images/games-icon/new/referral.png";

import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";

const MobLeftbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sportsData } = useSelector((state) => state.sports);
  const { isAuth } = useSelector((state) => state.auth);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`,
    );
  };

  const { user, balance, wallet } = useSelector((state) => state.auth);

  const [isClassAdded, setIsClassAdded] = useState(false);

  const handleLeftBarClick = () => {
    // htmlElement.style.overflow = "auto";
    document.body.classList.remove("leftbar-opened");
  };

  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
  }, []);
  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  return (
    <div className="leftbarSec">
      {isAuth && (
        <>
          <div className="d-flex profilemobsection d-md-none">
            <div className="profile-img d-md-none">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <div className="user-info">
              <Link className="user_name" to="/profile">
                {user?.mstruserid}
              </Link>
              <p>{user?.mobileno}</p>
            </div>
          </div>
          <div className="container upperbalnace d-md-none">
            <div className="d-flex align-items-center justify-content-between  mb-3">
              <div className="balance">
                <img src={WalletIcon} alt="wallet" />
                Balance
              </div>
              <div className="balance-amount">{wallet?.balance}</div>
            </div>

            <div className="row">
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}>
                <Button variant="" className="btn_withdraw w-100">
                  Withdraw
                </Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}>
                <Button variant="primary" className="btn_primary w-100">
                  Deposit
                </Button>
              </div>

              <div
                className="col-6"
                onClick={() => {
                  navigate("/bonus");
                }}>
                <Button variant="" className="btn_withdraw mt-2 w-100">
                  Bonus
                </Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/mybets");
                }}>
                <Button variant="" className="btn_withdraw  mt-2 w-100">
                  My Bets
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="games_link">
        <ul>
          <li>
            <div
              onClick={() => {
                navigate("/sports");
              }}>
              <img src={HomeIcon} alt="Home Icon" />
              <span>Home</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/sport/AGSE");
              }}>
              <img src={CricketIcon} alt="Home Icon" />
              <span>New Exchange</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/live-dealer");
              }}>
              <img src={CasinoIcon} alt="Casino" />
              <span>Live Dealer</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/top-games");
              }}>
              <img src={TopGames} alt="Casino" />
              <span>Top Games</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casinogames");
              }}>
              <img src={SlotsGames} alt="Casino" />
              <span>Slots</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/pragmaticplay");
              }}>
              <img src={PragmaticGames} alt="Casino" />
              <span>Pragmatic Play</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/playtech-games");
              }}>
              <img src={playtechGames} alt="Casino" />
              <span>Playtech Games</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/aura-games");
              }}>
              <img src={IndianGames} alt="Casino" />
              <span>Indian Casino Games</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/top-games");
              }}>
              <img src={CrashGames} alt="Casino" />
              <span>Crash Games</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/anvio-games");
              }}>
              <img src={EvolutionIcon} alt="Cricket Icon" />
              <span>Anvio Games</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/exchange/Cricket", {
                  state: { selectedTab: "2" },
                });
              }}>
              <img src={CricketIcon} alt="Cricket Icon" />
              <span>Exchange</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/aggapezugi-ezugi-lobby");
              }}>
              <img src={EzugiIcon} alt="Cricket Icon" />
              <span>Ezugi</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/evolution");
              }}>
              <img src={EvolutionIcon} alt="Cricket Icon" />
              <span>Evolution</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/xpg");
              }}>
              <img src={XPGICon} alt="Cricket Icon" />
              <span>XPG</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/supernowa");
              }}>
              <img src={SupernowaICon} alt="Cricket Icon" />
              <span>Supernowa</span>
            </div>
          </li>
          {/* <li>
            <div
              onClick={() => {
                navigate("/casino/vivo");
              }}>
              <img src={VivoIcon} alt="Cricket Icon" />
              <span>Vivo</span>
            </div>
          </li> */}
          <li>
            <div
              onClick={() => {
                navigate("/casino/qtech");
              }}>
              <img src={QtechIcon} alt="Cricket Icon" />
              <span>Qtech</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/spribe-aviator");
              }}>
              <img src={AviatorIcon} alt="Cricket Icon" />
              <span>Aviator</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/casino/aggapcrash88gaming-jetxt");
              }}>
              <img src={JetXIcon} alt="Cricket Icon" />
              <span>JetX</span>
            </div>
          </li>
          {/* <li>
            <div
              onClick={() => {
                navigate("/exchange/Soccer", {
                  state: { selectedTab: "3" },
                });
              }}
            >
              <img src={SoccerIcon} alt="Soccer Icon" />
              <span>Soccer</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/exchange/Tennis", {
                  state: { selectedTab: "4" },
                });
              }}
            >
              <img src={TennisIcon} alt=" Icon" />
              <span>Tennis</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/exchange/Basketball", {
                  state: { selectedTab: "2" },
                });
              }}
            >
              <img src={BasketballIcon} alt="Basketball Icon" />
              <span>Basketball</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/exchange/Horse%20Racing", {
                  state: { selectedTab: "2" },
                });
              }}
            >
              <img src={horseracingIcon} alt="horseracing Icon" />
              <span>Horseracing</span>
            </div>
          </li>
          <li>
            <div
              onClick={() => {
                navigate("/exchange/Politics", {
                  state: { selectedTab: "2" },
                });
              }}
            >
              <img src={PoliticsIcon} alt="Politics Icon" />
              <span>Politics</span>
            </div>
          </li> */}
        </ul>
      </div>

      {isAuth && (
        <div className="games_link">
          <ul className="account-menu">
            <li>
              <div
                onClick={() => {
                  navigate("/mybets");
                }}>
                <img src={BetIcon} alt="my bet" />
                <span>My Bets</span>
              </div>
            </li>
            <li>
              <div
                onClick={() => {
                  navigate("/bonus");
                }}>
                <img src={BonusImg} />
                <span className="bonus-space">Bonus</span>
              </div>
            </li>
            <li>
              <div
                onClick={() => {
                  navigate("/referral");
                }}>
                <img src={refferal} />
                <span className="bonus-space">Referral</span>
              </div>
            </li>
            <li>
              <div
                onClick={() => {
                  navigate("/cashier");
                }}>
                <img src={AcStatement} alt="account statement" />
                <span>Account Statement</span>
              </div>
            </li>
            <li onClick={() => dispatch(logoutUser(true))}>
              <div>
                {/* <LogoutIcon /> */}
                <img src={LogoutIconImg} />
                <span>Sign Out</span>
              </div>
            </li>
            <li>
              <div className="theme-btn">
                <button type="button" className="btn" onClick={toggleClass}>
                  <img src={SunLight} alt="sun" className="light_theme" />
                  <img src={MoonLight} alt="moon" className="dark_theme" />
                </button>
              </div>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobLeftbar;
